jQuery(document).ready(function(){	
	
	jQuery(function () {
	    jQuery('.work-slider').each(function(num, elem) {
	        elem = jQuery(elem);
	        elem.slick({
	            slidesToShow: 2,
				infinite: true,
				slidesToScroll: 1,
				arrows: false,
				//cssEase: 'linear',
				//dots: true,
				//autoplay: true,
				autoplaySpeed: 0,
				//speed: 10000,
				pauseOnHover: true,
				//autoplaySpeed: 2000,
				//prevArrow:'<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
				//nextArrow:'<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
				responsive: [
					{
					  breakpoint: 720,
					  settings: {
				      	centerMode: false,
				      	slidesToShow: 1,
				      	//adaptiveHeight: true
					  }
					}
				]			
	        });
	
	    });
	});
	/*
	jQuery('.work-slider').slick({
	  	slidesToShow: 2,
		infinite: true,
		slidesToScroll: 1,
		arrows: false,
		cssEase: 'linear',
		//dots: true,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 10000,
		pauseOnHover: true,
		//autoplaySpeed: 2000,
		//prevArrow:'<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
		//nextArrow:'<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
		responsive: [
			{
			  breakpoint: 720,
			  settings: {
		      	centerMode: false,
		      	//adaptiveHeight: true
			  }
			}
		]			
	});*/
	
});